import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import { useAuthStore } from "~/app/stores/auth";
import {PIGGYBANK_USE_DIRECTPAYMENT, SHOW_PRIZE_WHEEL, SCROLL_TO, DIRECT_PAYMENT_LISTING} from "~/constants/urls.ts";

const StoreSearchSchema = z.object({
  flowName: z.string().optional(),
  [PIGGYBANK_USE_DIRECTPAYMENT]: z.boolean().optional(),
  [SHOW_PRIZE_WHEEL]: z.boolean().optional(),
  [SCROLL_TO]: z.string().optional(),
  [DIRECT_PAYMENT_LISTING]: z.string().optional(),
});

export const Route = createFileRoute("/store")({
  beforeLoad: () => {
    const state = useAuthStore.getState();
    // TODO: REMOVE MOCK
    const isAuthenticated = state.isAuthenticated;
    const setModelOpenNotLogged = state.setModelOpenNotLogged;

    if (!isAuthenticated) {
      setModelOpenNotLogged(true);

      throw redirect({
        to: "/home",
      });
    }
    return true;
  },
  validateSearch: (search: unknown) => {
    const result = StoreSearchSchema.safeParse(search);
    return result.success ? result.data : {};
  },
});
